import React from 'react';
import { Typography, Link } from '@mui/material';
import { observer } from 'mobx-react';
import { smallTree, smallMSA, smallMSAOnly } from './data/seq2';
import { load } from './util';
const ListItem = ({ onClick, model, children, }) => (React.createElement("li", null,
    React.createElement(Link, { onClick: event => {
            model.setError(undefined);
            event.preventDefault();
            onClick();
        }, href: "#" },
        React.createElement(Typography, { display: "inline" }, children))));
const ImportFormExamples = observer(function ({ model, }) {
    return (React.createElement("ul", null,
        React.createElement(ListItem, { model: model, onClick: () => load(model, undefined, {
                uri: 'https://jbrowse.org/genomes/newick_trees/sarscov2phylo.pub.ft.nh',
                locationType: 'UriLocation',
            }) }, "230k COVID-19 samples (tree only)"),
        React.createElement(ListItem, { model: model, onClick: () => {
                model.setData({ msa: smallMSA, tree: smallTree });
            } }, "Small protein MSA+tree"),
        React.createElement(ListItem, { model: model, onClick: () => {
                model.setData({ msa: smallMSAOnly });
            } }, "Small MSA only"),
        React.createElement(ListItem, { model: model, onClick: () => load(model, {
                uri: 'https://jbrowse.org/genomes/multiple_sequence_alignments/pfam-cov2.stock',
                locationType: 'UriLocation',
            }) }, "PFAM SARS-CoV2 multi-stockholm"),
        React.createElement(ListItem, { model: model, onClick: () => load(model, {
                uri: 'https://jbrowse.org/genomes/multiple_sequence_alignments/Lysine.stock',
                locationType: 'UriLocation',
            }) }, "Lysine stockholm file"),
        React.createElement(ListItem, { model: model, onClick: () => load(model, {
                uri: 'https://jbrowse.org/genomes/multiple_sequence_alignments/PF01601_full.txt',
                locationType: 'UriLocation',
            }) }, "PF01601 stockholm file (SARS-CoV2 spike protein)"),
        React.createElement(ListItem, { model: model, onClick: () => load(model, {
                uri: 'https://jbrowse.org/genomes/multiple_sequence_alignments/europe_covid.fa',
                locationType: 'UriLocation',
            }) }, "Europe COVID full genomes (LR883044.1 and 199 other sequences)"),
        React.createElement(ListItem, { model: model, onClick: () => load(model, {
                uri: '/rhv_test-only.aligned_with_mafft_auto.fa',
                locationType: 'UriLocation',
            }, {
                uri: 'https://jbrowse.org/genomes/multiple_sequence_alignments/rhv_test-only.aligned_with_mafft_auto.nh',
                locationType: 'UriLocation',
            }) }, "MAFFT+VeryFastTree(17.9k samples)")));
});
export default ImportFormExamples;
//# sourceMappingURL=ImportFormExamples.js.map